import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_WOOP_REPORT_QUERY_KEY = 'apa-woop-report';

const getWoopReportQueryKey = (organizationId?: string) =>
  [APA_WOOP_REPORT_QUERY_KEY, organizationId] as const;

const getWoopReportQueryOptions = ({
  organizationId,
}: {
  organizationId?: string;
}) =>
  queryOptions({
    queryKey: getWoopReportQueryKey(organizationId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getWoopReport({
        organizationId: organizationId!,
      });
      return data || [];
    },
    enabled: !!organizationId,
  });

export const useWoopReportQuery = () => {
  const { currentOrganization } = useOrganizations();

  const { isLoading, data, error, refetch } = useQuery(
    getWoopReportQueryOptions({ organizationId: currentOrganization?.id })
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
